import React from 'react';
import { injectIntl } from 'react-intl';
import { ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { STUDIO_TEMPLATES } from '../../../constants';

const TEMPLATE_PREVIEW_IMAGES: Record<string, string> = {
  classic: '/img/hot-topic-studio/template-icons/classic.png',
  editorial: '/img/hot-topic-studio/template-icons/editorial.png',
  spotlight: '/img/hot-topic-studio/template-icons/spotlight.png'
};

const TemplatePreview: React.FC<{ template: string }> = ({ template }) => (
  <span className="studio-template-preview-frame" aria-hidden="true">
    <img
      src={TEMPLATE_PREVIEW_IMAGES[template] || TEMPLATE_PREVIEW_IMAGES.classic}
      className={`studio-template-preview ${template}`}
      alt=""
      draggable={false}
    />
  </span>
);

interface TemplateControlProps {
  intl: any;
  template: string;
  onChangeTemplate: (template: string) => void;
}

const TemplateControl: React.FC<TemplateControlProps> = ({ intl, template, onChangeTemplate }) => (
  <ToggleButtonGroup
    color="primary"
    value={template}
    exclusive
    fullWidth
    onChange={(_event, value: string | null) => value && onChangeTemplate(value)}
  >
    {STUDIO_TEMPLATES.map(option => (
      <ToggleButton key={option.id} value={option.id} className="studio-template-button">
        <TemplatePreview template={option.id} />
        <Typography variant="caption" component="span" className="studio-template-label">
          {intl.formatMessage({ id: option.labelId })}
        </Typography>
      </ToggleButton>
    ))}
  </ToggleButtonGroup>
);

export default injectIntl(TemplateControl);
